
import { createSelector } from 'reselect'
import getHasSampledProductDataSelector from 'modules/product/redux/selectors/get-has-sampled-product-data'

/**
 * @param {number} productId
 * @returns {boolean}
 */
const wasSuperLikedProductSelector = productId => createSelector(
  getHasSampledProductDataSelector(productId),
  (hasSampledData) => {
    return hasSampledData?.hasSampled === true && hasSampledData?.pssAnswer === 'super_like'
  }
)

export default wasSuperLikedProductSelector
